import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'article_static_strategy',
    props: {
    },

    data : function(){

        return {
            loading : false,
            locales : {en : true, ru : true}
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        },
    }),

    methods : {
        copy : function(){
            var t =  this.$refs['code1'].innerText

            f.copytext(t)

            this.core.sitemessage(this.$t('labels.copied'))
        }
    },
}